import React, { FunctionComponent, ReactNode } from 'react'

interface Props {
  children: ReactNode
  title?: string
  classNames?: string
}

const Card: FunctionComponent<Props> = ({
  classNames = '',
  children,
  title = '',
  titleClass = '',
}: Props) => (
  <div className={`px-4 py-6 bg-white rounded shadow-lg relative ${classNames}`}>
    {title && 
      <h3 className={`font-semibold text-gray-600 ${titleClass}`}>
        {title}
      </h3>
    }
    {children}
  </div>
)

export default Card
